import Common from "../../../../Common";

const Button = class extends Common {
	async browse(companyId: id, deviceId: id) {
		return this.get(`/company/${companyId}/pbx/device/${deviceId}/button`);
	}

	async read(companyId: id, deviceId: id, buttonId: id) {
		return this.get(`/company/${companyId}/pbx/device/${deviceId}/button/${buttonId}`);
	}

	async create(companyId: id, deviceId: id, data: any) {
		return this.post(`/company/${companyId}/pbx/device/${deviceId}/button`, data);
	}

	async update(companyId: id, deviceId: id, buttonId: id, data: any) {
		return this.patch(`/company/${companyId}/pbx/device/${deviceId}/button/${buttonId}`, data);
	}

	async delete(companyId: id, deviceId: id, buttonId: id) {
		return this.doDelete(`/company/${companyId}/pbx/device/${deviceId}/button/${buttonId}`);
	}
}

export default Button
